<footer class="footer">
  <img 
    src="{{utilityService.isWhiteLabelDomain ? './assets/images/logo-white-label.svg' : './assets/images/logo.svg'}}" 
    alt="Olleyes logo" 
    class="footer_image" />
</footer>
